export const SET_THEME = 'SET_THEME';
export const SET_INITIAL_THEME = 'SET_INITIAL_THEME';
export const SET_DEFAULT_THEME = 'SET_DEFAULT_THEME';
export const RESET_DEFAULT_THEME = 'RESET_DEFAULT_THEME';
